import IconRestaurant from '@/assets/icons/booking-restaurant.svg';
import IconBookCancel from '@/assets/icons/booking-cancel.svg';
import IconBookEdit from '@/assets/icons/edit.svg';
import ModalReservationForm from '@/components/modal_reservation_form/ModalReservationForm.vue';
import LoadingDots from '@/components/loading_dot/LoadingDot.vue';

export default {
  name: 'TripItem',
  components: {
    IconBookCancel,
    IconBookEdit,
    IconRestaurant,
    ModalReservationForm,
    LoadingDots
  },
  props: {
    bookingId: String,
    placeName: String,
    guestName: String,
    datetime: String,
    guests: String,
    comment: String,
    link: String,
    status: String
  },

  methods: {
    handleOnEditClicked: function() {
      this.$emit('editClicked', this.bookingId);
    },

    handleOnDeleteClicked: function() {
      this.$emit('deleteClicked', this.bookingId);
    }
  }
};
